// src/components/AddEditStaffModal/components/WorkInfoTab.js
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isBlueDartOrg } from '../../../../../utils/appHelper';
import ClientIdSection from '../ClientIdSection';
import ClientInfoComponent from './ClientInfoComponent';
import WorkInfoTabComponent from './WorkInfoTabComponent';

export default function WorkInfoTab({
    isEdit,
    formik,
    handlers,
    clientList,
    workTabHubNShiftList,
    setWorkTabHubNShiftList,
    overlapShifts,
    bothShiftsIsThere,
    setAllowHubZoneEdit,
    shiftsWithHub,
    setShiftsWithHub,
    getShiftfromHubId,
    getZonesFromHubId,
    allowHubZoneEdit,
    zonesWithHub,
    setZonesWithHub,
    zoneOptions,
    orgCustomerMappings,
    fetchHubListWithFilters,
    fetchBusinessList,
    isDedicatedSlotEnabled,
    isPinCodeOrg,
    isAmazonOrg,
}) {
    const hubs = useSelector((state) => state?.staff?.hubs);
    const isBlueDart = !!isBlueDartOrg?.();

    return (
        <Grid container spacing={2}>
            <WorkInfoTabComponent
                {...{
                    isEdit,
                    formik,
                    handlers,
                    clientList,
                    workTabHubNShiftList,
                    setWorkTabHubNShiftList,
                    overlapShifts,
                    bothShiftsIsThere,
                    setAllowHubZoneEdit,
                    shiftsWithHub,
                    setShiftsWithHub,
                    getShiftfromHubId,
                    getZonesFromHubId,
                    allowHubZoneEdit,
                    zonesWithHub,
                    setZonesWithHub,
                    zoneOptions,
                    orgCustomerMappings,
                    fetchHubListWithFilters,
                    fetchBusinessList,
                    isDedicatedSlotEnabled,
                    isPinCodeOrg,
                    isAmazonOrg,
                }}
            />
            <ClientIdSection
                {...{
                    isEdit,
                    workTabHubNShiftList,
                    hubs,
                    allowHubZoneEdit,
                    zonesWithHub,
                    setZonesWithHub,
                    zoneOptions,
                    formik,
                    overlapShifts,
                    bothShiftsIsThere,
                }}
            />
            {!isBlueDart && (
                <Grid item container spacing={2} style={{}}>
                    <ClientInfoComponent
                        formik={formik}
                        handlers={handlers}
                        clientList={clientList}
                    />
                </Grid>
            )}
        </Grid>
    );
}
